import React from "react";
import { Link } from "react-router-dom";
import { ScoreBadge } from "@/components/ScoreBadge";
import { assetUrl } from "@/lib/api";

const TYPE_LABEL = {
  software_review: "Software Review",
  product_review: "Product Review",
  comparison: "Comparison",
  buying_guide: "Buying Guide",
  guide: "Guide",
};

export function ArticleCard({ article }) {
  const isComparison = article.type === "comparison";
  const to = `${isComparison ? "/comparisons" : "/reviews"}/${article.slug}`;
  const isReview = article.type === "software_review" || article.type === "product_review";
  return (
    <Link to={to} data-testid={`article-card-${article.slug}`}
      className="group block border border-stone-900 bg-white transition-transform duration-200 hover:-translate-y-1 hover:hard-shadow">
      {article.featured_image ? (
        <div className="aspect-[16/9] overflow-hidden border-b border-stone-900 bg-stone-100">
          <img src={assetUrl(article.featured_image)} alt={article.featured_image_alt || article.title}
            className="w-full h-full object-cover" loading="lazy" />
        </div>
      ) : (
        <div className="aspect-[16/9] border-b border-stone-900 bg-stone-900 flex items-center justify-center">
          <span className="font-mono-pm text-[#CCFF00] text-xs tracking-[0.25em] uppercase">The PM Test</span>
        </div>
      )}
      <div className="p-5">
        <div className="flex items-center justify-between gap-3">
          <span className="font-mono-pm text-[10px] tracking-[0.2em] uppercase text-[#991B1B] font-semibold">
            {TYPE_LABEL[article.type] || "Article"}
          </span>
          {isReview && <ScoreBadge score={article.overall_score} passes={article.passes} size="sm" unscored={!article.is_scored} />}
        </div>
        <h3 className="font-serif-display text-xl font-bold leading-snug mt-3 text-stone-900 group-hover:text-[#991B1B] transition-colors">
          {article.title}
        </h3>
        {article.excerpt && <p className="text-sm text-stone-600 mt-2 line-clamp-2">{article.excerpt}</p>}
        {article.category && <div className="font-mono-pm text-[10px] tracking-wider uppercase text-stone-400 mt-3">{article.category}</div>}
      </div>
    </Link>
  );
}
